import auth from "@/router/middleware/auth";
import permission from "@/router/middleware/permission";

export default [
//******* Tienda *******
    {
        path: '/store',
        name: 'store.store',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/store/catalog'),
    },
    {
        path: '/store/cart',
        name: 'store.store.cart',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/store/cart')
    },
    {
        path: '/store/confirm',
        name: 'store.store.confirm',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/store/confirm')
    },
//******* Mis pedidos *******
    {
        path: '/orders',
        name: 'store.orders',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/orders/orders')
    },
    {
        path: '/orders/:id',
        name: 'store.orders.view',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/orders/view')
    },
//******* Mis Devoluciones *******
    {
        path: '/returns',
        name: 'store.orders.returns',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/orders/returns/index')
    },
    // {
    //     path: '/orders/returns/:id',
    //     name: 'store.orders.returns.view',
    //     meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
    //     component: () => import('../views/store/orders/returns/view')
    // },
//******* Mis Finanzas *******
    {
        path: '/credit',
        name: 'store.finance.credit',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/finance/credit')
    },
    {
        path: '/finance/invoice',
        name: 'store.finance.invoice',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/finance/invoice')
    },
    {
        path: '/finance/payment',
        name: 'store.finance.payment',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/finance/payment')
    },
    {
        path: '/finance/wallet',
        name: 'store.finance.wallet',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/finance/wallet')
    },
//******* Mi cuenta *******
    {
        path: '/account',
        name: 'store.account',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/account/contact')
    },
    {
        path: '/account/address',
        name: 'store.account.address',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/account/address')
    },

    //******* AYUDA *******
    {
        path: '/faq',
        name: 'store.faq',
        meta: {middleware: [auth, permission], permission: 'b2b.store_client'},
        component: () => import('../views/store/help/faq'),
    },
]